import { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";


import { practicesOptions, procoDocsDocumentTypesOptions } from "../../../../../lib/systemData";
import { procofilesActions } from "../../../../../store/procofiles";
import CustomSelect from "../../../../common/interactive/CustomSelect";
import Button from "../../../../common/Button";
import InputBox from "../../../../common/interactive/InputBox";
import { changeWordingForWC } from "../../../../../lib/misc";
import { visibleProcoDocumentsForTab } from "../../../../../lib/docs";

import classes from './DocumentsFilters.module.css'

const SOURCE_OPTIONS = [
    {
        label: 'ProcoDocs',
        value: 'ProCo'
    },
    {
        label: 'Law Firm',
        value: 'Law Firm'
    }
]

export default function DocumentsFilters() {
    const dispatch = useDispatch()
    const activeCase = useSelector(state => state.case.activeCase)

    const [selectedDocumentTypeId, setSelectedDocumentTypeId] = useState(null)
    const [selectedSource, setSelectedSource] = useState(null)
    const [keyword, setKeyword] = useState(null)
    const [selectedpracticesId, setSelectedpracticesId] = useState(null)

    const documents = useMemo(() => {
        const data = visibleProcoDocumentsForTab(activeCase?.procodocs_documents)
        return [...data].sort((x, y) => new Date(y.created_at) - new Date(x.created_at))
    }, [activeCase?.procodocs_documents])

    const types = () => {
        const data = procoDocsDocumentTypesOptions()

        return data.map(item => {
            return {
                ...item,
                label: item.label === 'HIPAA' ? changeWordingForWC(activeCase, 'HIPAA', 'WC-207') : item.label
            }
        })
    }

    const applyFilters = (docTypeId, source, searchKeyword, practiceId) => {
        let results = documents
        if (docTypeId !== null) {
            results = results.filter(item => item.procodocs_document_type_id === docTypeId)
        }
        if (source !== null) {
            results = results.filter(item => item.source === source)
        }
        if (searchKeyword) {
            results = results.filter(item => item.file_name?.toLowerCase().includes(searchKeyword))
        }
        if (practiceId !== null) {
            results = results.filter((item) => (item.practices ?? []).some((elem) => elem === practiceId))
        }
        dispatch(procofilesActions.setFilterResult(results))
    }

    const filterDocumentType = (value) => {
        setSelectedDocumentTypeId(value.data.value)
        applyFilters(value.data.value, selectedSource, keyword, selectedpracticesId)
    }

    const filterSourceType = (value) => {
        setSelectedSource(value.data.value)
        applyFilters(selectedDocumentTypeId, value.data.value, keyword, selectedpracticesId)
    }

    const searchKeywordHandler = (value) => {
        
        const searchValue = value.data.value?.toLowerCase() || null
        setKeyword(searchValue)
        applyFilters(selectedDocumentTypeId, selectedSource, searchValue, selectedpracticesId)
    }

    const filterPracticesHandler = (value) => {
        setSelectedpracticesId(value.data.value)
        applyFilters(selectedDocumentTypeId, selectedSource, keyword, value.data.value)
    }

    function clearFilters() {
        dispatch(procofilesActions.setFilterResult(null))
        setSelectedSource(null)
        setSelectedDocumentTypeId(null)
        setSelectedpracticesId(null)
        setKeyword(null)
    }

    return <>
        <div className={classes.label}>Filter by: </div>
        <InputBox label={'Keyword'} action={searchKeywordHandler} currentValue={keyword} setStyle={'bk_white'} isAFilter={true}/>
        <CustomSelect label={'Document Type'} optionsData={types()} preSelectedValue={selectedDocumentTypeId} action={filterDocumentType} hasRemove={true} isAFilter={true}/>
        <CustomSelect label={'Source'} optionsData={SOURCE_OPTIONS} preSelectedValue={selectedSource} action={filterSourceType} hasRemove={true} isAFilter={true}/>
        <CustomSelect label={'Practice'} optionsData={practicesOptions()} preSelectedValue={selectedpracticesId} action={filterPracticesHandler} hasRemove={true} isAFilter={true}/>
        <Button click={clearFilters}>Clear All</Button>
    </>
}